class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopMedia = window.matchMedia('(min-width: 990px)');
    this.hoverMedia = window.matchMedia('(hover: hover)');
    this.leaveTimeout = null;
    this.hoverEnabled = false;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onSummaryFocus = this.onSummaryFocus.bind(this);

    if (this.summary) {
      this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.hasAttribute('open'));
      this.summary.addEventListener('focus', this.onSummaryFocus);
    }

    this.mainDetailsToggle.addEventListener('keydown', this.onKeyDown);
    this.desktopMedia.addEventListener('change', this.onMediaChange);
    this.hoverMedia.addEventListener('change', this.onMediaChange);

    if (this.shouldEnableHover()) {
      this.enableHover();
    }
  }

  disconnectedCallback() {
    this.disableHover();
    this.desktopMedia.removeEventListener('change', this.onMediaChange);
    this.hoverMedia.removeEventListener('change', this.onMediaChange);
    if (this.summary) {
      this.summary.removeEventListener('focus', this.onSummaryFocus);
    }
  }

  shouldEnableHover() {
    return this.desktopMedia.matches && this.hoverMedia.matches;
  }

  enableHover() {
    if (this.hoverEnabled) return;
    this.hoverEnabled = true;
    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
  }

  disableHover() {
    if (!this.hoverEnabled) return;
    this.hoverEnabled = false;
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    clearTimeout(this.leaveTimeout);
    this.leaveTimeout = null;
    this.close();
  }

  onMediaChange() {
    if (this.shouldEnableHover()) {
      this.enableHover();
      return;
    }
    this.disableHover();
  }

  onMouseEnter() {
    if (!this.hoverEnabled) return;
    clearTimeout(this.leaveTimeout);
    this.open();
  }

  onMouseLeave() {
    if (!this.hoverEnabled) return;
    clearTimeout(this.leaveTimeout);
    this.leaveTimeout = setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    }, 120);
  }

  onSummaryFocus() {
    if (this.shouldEnableHover()) {
      this.open();
    }
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.mainDetailsToggle.hasAttribute('open')) {
      event.preventDefault();
      this.close();
      this.summary?.focus();
    }
  }

  open() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
    }
    if (this.summary) this.summary.setAttribute('aria-expanded', true);
  }

  onToggle() {
    super.onToggle();

    if (this.summary) {
      this.summary.setAttribute('aria-expanded', this.mainDetailsToggle.hasAttribute('open'));
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
